enum PortfolioCreateDialogFields {
	FILENAME = 'filename'
}

export default PortfolioCreateDialogFields;